"use client";

import { useEffect, useState, type FC, type Ref } from "react";
import { Flex } from "@huub-web/ui/components/Flex";
import { ExpansionPanel } from "@huub-web/ui/components/ExpansionPanel";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";
import type { TemplateIcon } from "../../types/TemplateIcon";

export interface ExpansionPanelTemplateProps {
  title: string;
  templates: TemplateCollection;
  open?: boolean;
  icon?: TemplateIcon;
}

export const ExpansionPanelTemplate: FC<
  ExpansionPanelTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ title, templates, open, icon, ref }) => {
  const [isOpen, setIsOpen] = useState(open ?? false);

  useEffect(() => {
    setIsOpen(open ?? false);
  }, [open]);

  return (
    <ExpansionPanel
      ref={ref}
      title={title}
      icon={icon}
      indicatorVariant={icon ? "infoSurface" : undefined}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Flex gap="s" direction="column">
        <TemplatesParser level={1} templates={templates} />
      </Flex>
    </ExpansionPanel>
  );
};
